import { createFileRoute } from "@tanstack/react-router";

import { ComplianceManagerPage } from "@/components/pages/ComplianceManagerPage";
import { FeatureGate } from "@/components/shared/FeatureGate";
import type { ComplianceManagerTab } from "@/lib/compliance-manager";
import { FEATURES } from "@/lib/features";

type ComplianceManagerSearch = {
  tab?: ComplianceManagerTab;
};

const VALID_TABS: ComplianceManagerTab[] = [
  "open",
  "recently-completed",
  "history",
  "tasks",
];

export const Route = createFileRoute("/_authenticated/compliance-manager/")({
  validateSearch: (
    search: Record<string, unknown>,
  ): ComplianceManagerSearch => ({
    tab: VALID_TABS.includes(search.tab as ComplianceManagerTab)
      ? (search.tab as ComplianceManagerTab)
      : undefined,
  }),
  component: ComplianceManagerRoute,
});

function ComplianceManagerRoute() {
  return (
    <FeatureGate
      feature={FEATURES.COMPLIANCE_TASKS}
      featureName="Compliance tasks"
    >
      <ComplianceManagerPage />
    </FeatureGate>
  );
}
